import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/')({
  component: AdminIndex,
});

function AdminIndex() {
  return (
    <div className="max-w-2xl">
      <h1 className="text-xl font-semibold mb-6">Admin</h1>
      <div className="grid grid-cols-2 gap-4">
        <Link
          to="/admin/users"
          className="rounded-lg border border-border p-5 hover:bg-muted transition-colors"
        >
          <div className="font-medium mb-1">Users</div>
          <div className="text-sm text-muted-foreground">Search and manage user accounts</div>
        </Link>
        <Link
          to="/admin/properties"
          className="rounded-lg border border-border p-5 hover:bg-muted transition-colors"
        >
          <div className="font-medium mb-1">Properties</div>
          <div className="text-sm text-muted-foreground">Browse all properties, transfer ownership</div>
        </Link>
      </div>
    </div>
  );
}
